import { render, staticRenderFns } from "./PurchaseinvoicesOther.vue?vue&type=template&id=22d4b13f&"
import script from "./PurchaseinvoicesOther.vue?vue&type=script&lang=js&"
export * from "./PurchaseinvoicesOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports